import React, { useState, useEffect } from "react";

import { Tooltip } from "@mui/material";
// import { blogList, ChangeStateStatus } from '../../Services/Blog/BlogApi';
// import { Eye, EyeOff } from "lucide-react"; // Optional: if using lucide icons

import dayjs from "dayjs";
import NoResultFoundModel from "../NoResultFoundModal";
import StatusChangeModal from "../../../StatusChangeModal";
import Android12Switch from "../../../Android12Switch";
import SuccessPopupModal from "../SuccessPopupModal";
import { useAuth } from "../../../Context/AuthContext";
import { blogList, ChangeStateStatus } from "../../../Services/Blog/BlogApi";
import AdminUserAddUpdateModal from "./AdminUserAddUpdateModal";
import {
  changeUserStatus,
  userList,
} from "../../../Services/Admin User/AdminUser";
const AdminUserList = () => {
  const [stateChangeStatus, setStateChangeStatus] = useState("");
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [isAddUpdateActionDone, setIsAddUpdateActionDone] = useState(false);
  const [showBlogViewModal, setShowBlogViewModal] = useState(false);
  const [showStatusChangeModal, setShowStatusChangeModal] = useState(false);
  const [visiblePasswords, setVisiblePasswords] = useState({});

  const [totalRecords, setTotalRecords] = useState(-1);
  const [modelAction, setModelAction] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState();
  const [showSuccessModal, setShowSuccessModal] = useState();
  const [searchKeyword, setSearchKeyword] = useState("");
  const [totalCount, setTotalCount] = useState(null);
  const [pageSize, setPageSize] = useState(30);
  const [errorMessage, setErrorMessage] = useState(false);
  const [blogListData, setBlogListData] = useState([]);

  const { setLoader, user } = useAuth();


  const [modelRequestData, setModelRequestData] = useState({
    customerID: null,
    customerKeyID: null,
    companyID: null,
    talukaID: null,
    talukaName: null,
    name: null,
    mobileNo: null,
    address: null,
    adharNumber: null,
    adharFrontImageURL: null,
    adharBackImageURL: null,
    status: null,
    createdOnDate: null,
  });

  const toggleVisibility = (adminKeyID) => {
    setVisiblePasswords((prev) => ({
      ...prev,
      [adminKeyID]: !prev[adminKeyID],
    }));
  };
  useEffect(() => {
    GetMasterBlogListData(1, "");
  }, []);

  useEffect(() => {
    if (isAddUpdateActionDone) {
      GetMasterBlogListData(1, "");
      setSearchKeyword('')
    }
    setIsAddUpdateActionDone(false);

    setTimeout(() => {
      GetMasterBlogListData(1, "");
    }, 2000);
  }, [isAddUpdateActionDone]);

  const GetMasterBlogListData = async (pageNumber, searchKeywordValue) => {
    // debugger
    // setLoader(true);
    try {
      const data = await userList({
        pageSize,
        pageNo: pageNumber - 1, // Page numbers are typically 0-based in API calls
        searchKeyword:
          searchKeywordValue === undefined ? searchKeyword : searchKeywordValue,
      });

      if (data) {
        if (data?.data?.statusCode === 200) {
          setLoader(false);
          if (data?.data?.responseData?.data) {
            const MasterStateListData = data.data.responseData.data;
            const totalItems = data.data?.totalCount; // const totalItems = 44;
            setTotalCount(totalItems);
            const totalPages = Math.ceil(totalItems / pageSize);
            setTotalPage(totalPages);
            setTotalRecords(MasterStateListData.length);
            setBlogListData(MasterStateListData);
          }
        } else {
          setErrorMessage(data?.data?.errorMessage);
          setLoader(false);
        }
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };



  const addMasterStateBtnClick = () => {
    setModelRequestData({
      ...modelRequestData,
      adminID: null,
      machineID: null,
      Action: null,
    });

    setShowCustomerModal(true);
  };
  const blogEditBtnClicked = (row) => {
    setModelRequestData({
      ...modelRequestData,
      adminKeyID: row.adminKeyID,
      Action: "Update",
    });

    setShowCustomerModal(true);
  };

  const viewBlogBtnClick = (row) => {
    setModelRequestData({
      ...modelRequestData,
      BlogKeyID: row.BlogKeyID,
      Action: "Update",
    });
    setShowBlogViewModal(true);
  };

  const handleSearch = (e) => {
    let searchKeywordValue = e.target.value;
    const trimmedValue = searchKeywordValue.replace(/^\s+/g, "");
    const capitalizedValue =
      trimmedValue.charAt(0).toUpperCase() +
      trimmedValue.slice(1).toLowerCase();
    if (searchKeywordValue.length === 1 && searchKeywordValue.startsWith(" ")) {
      searchKeywordValue = searchKeywordValue.trimStart();
      return;
    }
    setSearchKeyword(capitalizedValue);
    GetMasterBlogListData(1, capitalizedValue);
  };
  const closeAllModal = () => {
    setShowSuccessModal(false);
  };

  const handleStatusChange = (row) => {
    setStateChangeStatus(row); // You can set only relevant data if needed
    setShowStatusChangeModal(true);
  };

  const confirmStatusChange = async (row) => {
    try {
      const { adminKeyID } = row; // Destructure to access only what's needed
      const response = await changeUserStatus(adminKeyID);

      if (response && response.data.statusCode === 200) {
        setShowStatusChangeModal(false);
        setStateChangeStatus(null);
        GetMasterBlogListData(1, null);
        setShowSuccessModal(true);
        setModelAction("Admin status changed successfully.");
      } else {
        console.error(response?.data?.errorMessage);
        setShowSuccessModal(true);
        setModelAction("Failed to change employee status.");
      }
    } catch (error) {
      console.error("Error changing employee status:", error);
      setShowSuccessModal(true);
      setModelAction("An error occurred while changing the employee status.");
    }
  };

  return (
    <>
      <div className="card w-full max-w-[60vh] mx-auto h-auto">
        <div className="card-body p-2 bg-white shadow-md rounded-lg">
          {/* Top controls */}
          <div className="d-flex justify-content-between align-items-center mb-1">
            <h5 className="m-0">Admin</h5>
            <button
              onClick={() => addMasterStateBtnClick()}
              className="btn btn-primary btn-sm d-inline d-sm-none"
            >
              <i className="fa-solid fa-plus" style={{ fontSize: "11px" }}></i>
              <span className="d-inline d-sm-none"> Add</span>
            </button>
          </div>
          <div className="d-flex justify-content-between align-items-center mb-1">
            <input
              type="text"
              className="form-control "
              placeholder="Search Admin "
              style={{ maxWidth: "350px" }}
              value={searchKeyword}
              onChange={(e) => {
                handleSearch(e);
              }}
            />
            {/* <Tooltip title="Add State"> */}
            <button
              onClick={() => addMasterStateBtnClick()}
              style={{ background: "#f08143" }}
              className="btn text-white btn-sm d-none d-sm-inline"
            >
              <i className="fa-solid fa-plus" style={{ fontSize: "11px" }}></i>
              <span className="d-none d-sm-inline"> Add Admin</span>
            </button>
            {/* </Tooltip> */}
          </div>

          {/* Table */}
          <div
            className="table-responsive"
            style={{
              maxHeight: "65vh",
              overflowY: "auto",
              position: "relative",
            }}
          >
            <table className="table table-bordered table-striped">
              <thead
                className="table-light"
                style={{ position: "sticky", top: -1, zIndex: 1 }}
              >
                <tr className="text-nowrap">
                  <th className="text-center">Sr No</th>
                  <th className="text-center">First Name</th>
                  <th className="text-center">last Name</th>
                  <th className="text-center">Phone Number</th>
                  <th className="text-center">Email</th>
                  <th className="text-center">Password</th>

                  {/* <th className="text-center">
                  Password
              
                </th>
                <th className="text-center">
                 Confirm Password
              
                </th> */}

                  <th className="text-center">Status</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {blogListData?.map((row, idx) => {
                  // ✅ Skip rendering if the row ID matches the logged-in user's ID
                  // if (row.adminKeyID === user.id) return null;

                  return (
                    <tr key={idx}>
                      <td className="text-center">{idx + 1}</td>
                      <td className="text-center">{row.firstName}</td>
                      <td className="text-center">{row.lastName}</td>
                      <td className="text-center">{row.phoneNumber}</td>
                      <td className="text-center">{row.email}</td>
                      {/* <td className="text-center">{row.password || "-"}</td> */}
                      <td className="text-center">
                        {row.password ? (
                          <div className="flex items-center justify-center gap-2">
                            <span>
                              {visiblePasswords[row.adminKeyID]
                                ? row.password
                                : "••••••"}
                            </span>
                            <button
                              onClick={() => toggleVisibility(row.adminKeyID)}
                              className="focus:outline-none"
                            >
                              {visiblePasswords[row.adminKeyID] ? (

                                <i class="fa-solid fa-eye-slash"></i>
                              ) : (
                                <i class="fa-solid fa-eye"></i>
                              )}
                            </button>
                          </div>
                        ) : (
                          "-"
                        )}
                      </td>


                      <td className="text-center">
                        <Tooltip
                          title={
                            row.status === "InActivate" ? "Disable" : "Enable"
                          }
                        >
                          {row.status === "InActivate" ? "Enable" : "Disable"}
                          <Android12Switch
                            style={{ padding: "8px" }}
                            onClick={() => handleStatusChange(row)}
                            checked={row.status === "Activate"}
                            disabled={row.adminKeyID === user.id}
                          />
                        </Tooltip>
                      </td>

                      <td
                        className="text-center actionColSticky"
                        style={{ zIndex: 4 }}
                      >
                        <div
                          className="d-inline-flex justify-content-center align-items-center"
                          style={{ gap: "10px" }}
                        >
                          <Tooltip title="Update Admin">
                            <button
                              style={{
                                padding: "1px",
                                fontSize: "12px",
                                height: "28px",
                                color: "white",
                                width: "28px",
                                background: "#f08143",
                              }}
                              onClick={() => blogEditBtnClicked(row)}
                              className="btn-sm btn text-white"
                            >
                              <i className="fa-regular fa-pen-to-square"></i>
                            </button>
                          </Tooltip>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {totalRecords <= 0 && (
              <NoResultFoundModel totalRecords={totalRecords} />
            )}
          </div>
          <div className="d-flex justify-content-end ">
            {/* {totalCount > pageSize && (
            <PaginationComponent totalPages={totalPage} currentPage={currentPage} onPageChange={handlePageChange} />
          )} */}
          </div>
        </div>
      </div>

      {/* {openMasterStateModal && (
      <AddUpdateMasterStateModal
        show={openMasterStateModal}
        onHide={() => setOpenMasterStateModal(false)}
        modelRequestData={modelRequestData}
        setModelRequestData={setModelRequestData}
        setIsAddUpdateActionDone={setIsAddUpdateActionDone}
      />
    )}
      

    <StatusChangeModal
      open={showStatusChangeModal}
      onClose={() => setShowStatusChangeModal(false)}
      onConfirm={() => confirmStatusChange(stateChangeStatus, user)} // Pass the required arguments
    />

    {showSuccessModal && (
      <SuccessPopupModal
        show={showSuccessModal}
        onHide={() => closeAllModal()}
        setShowSuccessModal={setShowSuccessModal}
        modelAction={modelAction}
      />
    )} */}

      <StatusChangeModal
        open={showStatusChangeModal}
        onClose={() => setShowStatusChangeModal(false)}
        onConfirm={() => confirmStatusChange(stateChangeStatus, user)} // Pass the required arguments
      />

      {showCustomerModal && (
        <AdminUserAddUpdateModal
          show={showCustomerModal}
          onHide={() => setShowCustomerModal(false)}
          modelRequestData={modelRequestData}
          setModelRequestData={setModelRequestData}
          setIsAddUpdateActionDone={setIsAddUpdateActionDone}
        />
      )}

      {showSuccessModal && (
        <SuccessPopupModal
          show={showSuccessModal}
          onHide={() => closeAllModal()}
          setShowSuccessModal={setShowSuccessModal}
          modelAction={modelAction}
        />
      )}
    </>
  );
};

export default AdminUserList;
